module.exports = "/images/tatler.png?793bb7829347900a7e8983748017cffc";